/* unplugin-vue-components disabled */import { render } from "./VideoPreviewer.vue?vue&type=template&id=c6c2e8f0&scoped=true"
import script from "./VideoPreviewer.vue?vue&type=script&lang=js"
export * from "./VideoPreviewer.vue?vue&type=script&lang=js"

import "./VideoPreviewer.vue?vue&type=style&index=0&id=c6c2e8f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c2e8f0"]])

export default __exports__